/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Represents an error that occurred during rebalancing.
 * @export
 * @interface RebalancingError
 */
export interface RebalancingError {
    /**
     * Optional identifier of the affected resource (node ID, pod name, etc.).
     * @type {string}
     * @memberof RebalancingError
     */
    'affectedResource'?: string;
    /**
     * The error code categorizing the error.
     * @type {string}
     * @memberof RebalancingError
     */
    'code'?: RebalancingErrorCodeEnum;
    /**
     * Human-readable error message.
     * @type {string}
     * @memberof RebalancingError
     */
    'message'?: string;
}

export const RebalancingErrorCodeEnum = {
    REBALANCING_ERROR_CODE_UNSPECIFIED: 'REBALANCING_ERROR_CODE_UNSPECIFIED',
    GENERATION_FAILED: 'GENERATION_FAILED',
    UPSCALING_FAILED: 'UPSCALING_FAILED',
    NODE_DRAIN_FAILED: 'NODE_DRAIN_FAILED',
    NODE_CREATE_FAILED: 'NODE_CREATE_FAILED',
    NODE_PREPARE_FAILED: 'NODE_PREPARE_FAILED',
    NODE_DELETE_FAILED: 'NODE_DELETE_FAILED',
    TIMEOUT: 'TIMEOUT',
    INSUFFICIENT_SAVINGS: 'INSUFFICIENT_SAVINGS',
    UNKNOWN: 'UNKNOWN',
    INSUFFICIENT_CAPACITY: 'INSUFFICIENT_CAPACITY',
    OPERATION_CANCELED: 'OPERATION_CANCELED',
    QUOTA_EXCEEDED: 'QUOTA_EXCEEDED'
} as const;

export type RebalancingErrorCodeEnum = typeof RebalancingErrorCodeEnum[keyof typeof RebalancingErrorCodeEnum];


